import { BaseService } from "./baseService";
import { SpecialtyDto, specialtyFormData } from "../types/specialty"; // Βεβαιώσου ότι το path είναι σωστό

class SpecialtyService extends BaseService<SpecialtyDto, typeof specialtyFormData> {
  constructor() {
    super("/Specialties");
  }
}

export const specialtyService = new SpecialtyService();